<template lang='pug'>
  el-card.detail(v-if='opts && data')
    div(v-if="row>=0") 第{{typeof(parseInt(data.row))=='number'?parseInt(data.row)+1:''}}行:
    div.pop
      div.row(v-if="editable")
        span.lb(v-for="v in opts.rowActions", style='margin-right:20px')
          a(@click="v.handler(data)") {{v.text}}
        div.lb
          slot(name='detailAction')
      div.row(v-for="(v, k) in opts.columns" :style="rowStyle(v)")
        span.lb(v-if="v.text != '详情'") {{v.label}}
        span.ct(v-if="v.text != '详情' && editable" :style="cellStyle(v)")
          table-cell(
            :mode="opts.editable?'form':'area'"
            :editable="opts.editable"        
            :opts="opts"
            :row="row"
            :rowObj="data"
            :col="k"
            v-model="data[v.label]",
            @cell-blur="update(v.label, arguments)")
        span.ct(v-else-if="v.text != '详情' ") {{data[v.label]}}
    slot(name="moreDetail")
</template>

<script>
// Generated by CoffeeScript 2.3.0
var m;

export default m = {
  props: {
    opts: Object,
    data: Object,
    row: Number
  },
  data: function() {
    return {
      editable: true
    };
  },
  components: {
    'table-cell': require('./cell')
  },
  methods: {
    update: function(label, [value]) {
      if (this.opts.update) {
        return this.opts.update(this.data, label, value);
      }
      if (value == null) {
        value = '';
      }
      this.data[label] = value;
      return app.api.update({
        tableName: this.opts.tableName,
        _id: this.data._id,
        data: {
          [`${label}`]: value
        }
      });
    },
    cellStyle: function(v) {
      var style;
      style = '';
      if (v.width) {
        style = `width:${v.width}px;`;
      }
      return style;
    },
    rowStyle: function(v) {
      var style;
      style = '';
      if (v.type === 'textarea') {
        style = "width:100%;";
      } else if (v.width && (v.width >= 100)) {
        style = `width:${v.width + 150}px;`;
      } else {
        style = "width:250px;";
      }
      return style;
    }
  },
  mounted: function() {
    return this.editable = this.opts.editable;
  }
};

// if @data.permissions["所有人"] == "读取" || @data.permissions["#{app.user.account}"] == "读取"
//   @editable = false
</script>
